import styled from 'styled-components';
import { Form, Card, Radio } from 'antd';

const Container = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: end;
`;

const SearchInputActions = styled.div`
  max-width: 150px;
`;

const SearchInput = styled.div`
  flex: 1 1 200px;
  min-width: 80%;
`;

const FormItem = styled(Form.Item)`
  & .ant-col.ant-form-item-control {
    margin-bottom: -10px;
  }

  & .ant-form-item-has-error > ant-col.ant-form-item-control {
    height: auto;
  }
`;

const SummaryCard = styled(Card)`
  margin-top: 20px;
  margin-bottom: 20px;
  & .ant-col {
    padding: 5px;
  }
`;

const FirstName = styled.span`
  margin-top: 20px !important;
  font-size: 14px;
`;

const AssetRadioGroup = styled(Radio.Group)`
  width: 100%;
  
  .styledRadio{
    border: 1px solid #E3E6EF;
    margin-bottom: 8px;
    width: 100% !important;
    border-radius: 10px;
    padding: 15px 5px;
    display: flex;

    &: hover {
      border-color: ${({ theme }) => theme['primary-color']} !important;
      // color: ${({ theme }) => theme['primary-color']} !important;
    }
} 
`

export { Container, SearchInputActions, SearchInput, FormItem, SummaryCard, FirstName, AssetRadioGroup };
